import styled from "styled-components";

// ── Layout ──────────────────────────────────────────────────────────────────

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// ── Country / store picker ───────────────────────────────────────────────────

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px;
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CountryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px 16px;
  border: 1px dashed var(--disabled);
  border-radius: 4px;
  padding: 16px;
`;

export const CountryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const StoresPanel = styled.div`
  border: 1px solid var(--grey200);
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CountryStoresBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CountryStoresHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CountryLabel = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const SelectedRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

// ── Toolbar ──────────────────────────────────────────────────────────────────

export const Toolbar = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
`;

export const ToolbarSearch = styled.div`
  flex: 1;
  min-width: 240px;
  max-width: 400px;
`;

export const ResultCount = styled.span`
  font-size: 14px;
  color: var(--grey718);
`;

export const ExportSelect = styled.select`
  height: 32px;
  border: 1px solid var(--disabled);
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  background: #fff;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorBanner = styled.div`
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 4px;
  background: #ffe3e3;
  border: 1px solid #d92d20;
  color: #7a271a;
`;

// ── User table ───────────────────────────────────────────────────────────────

export const UserList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid var(--grey200);
`;

const ROW_COLUMNS = "56px 2.5fr 1.5fr 1fr 1fr 1fr";

export const HeaderRow = styled.li`
  display: grid;
  grid-template-columns: ${ROW_COLUMNS};
  gap: 16px 8px;
  padding: 10px 4px;
  align-items: center;
  background: var(--grey100);
  border-bottom: 1px solid var(--grey200);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--grey718);
`;

export const UserRow = styled.li`
  display: grid;
  grid-template-columns: ${ROW_COLUMNS};
  gap: 16px 8px;
  padding: 12px 4px;
  align-items: center;
  border-bottom: 1px solid var(--grey200);
`;

export const SortButton = styled.button`
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font: inherit;
  color: inherit;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 4px;

  &:hover {
    background: #ebebeb;
  }
`;

export const UserName = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

export const UserEmail = styled.div`
  font-size: 13px;
  color: var(--grey718);
`;

export const RoleCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const RoleCheck = styled.span<{ $color: string }>`
  color: ${(p) => p.$color};
  font-size: 16px;
  font-weight: 700;
`;

export const CountryNameCell = styled.div`
  width: 100%;
  font-size: 13px;
  color: var(--grey718);
  text-align: center;
`;

export const CountryTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
`;

export const CountryTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #c7d7e7;
  background: #edf4fb;
  color: #003e72;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
`;

export const CountryEmptyTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #d4d4d4;
  background: #f7f7f7;
  color: var(--grey700);
  font-size: 12px;
  font-weight: 500;
`;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
`;

export const PageInfo = styled.span`
  font-size: 14px;
`;

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: var(--grey718);
`;
